var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLinkedinIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 20.9999V13.3086C21 9.52861 20.1862 6.64111 15.7762 6.64111C13.65 6.64111 12.2325 7.79611 11.655 8.89861H11.6025V6.98236H7.42871V20.9999H11.7862V14.0436C11.7862 12.2061 12.1275 10.4474 14.385 10.4474C16.6162 10.4474 16.6425 12.5211 16.6425 14.1486V20.9736H21V20.9999Z",
    fill: "#F9F3EE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.341309 6.98242H4.69881V20.9999H0.341309V6.98242Z",
    fill: "#F9F3EE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.52 0C1.12875 0 0 1.12875 0 2.52C0 3.91125 1.12875 5.06625 2.52 5.06625C3.91125 5.06625 5.04 3.91125 5.04 2.52C5.04 1.12875 3.91125 0 2.52 0Z",
    fill: "#F9F3EE"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinIcon);
export default __webpack_public_path__ + "static/media/linkedin-icon.2c489bc3252fb0c361aa04766620181b.svg";
export { ForwardRef as ReactComponent };